<template>
  <div class="class-settings">
    <div class="container">
      <el-page-header class="nav" @back="$router.go(-1)" content="班级设置">
      </el-page-header>
      <el-tabs
        v-model="activeName"
        type="border-card"
        style="margin-bottom: 20px"
      >
        <el-tab-pane label="班级信息" name="1">
          <el-form
            :model="classInfo"
            :rules="rules"
            ref="classInfo"
            label-width="100px"
            style="padding: 30px 140px 0"
          >
            <el-form-item label="班级名称" prop="name">
              <el-input
                v-model="classInfo.name"
                placeholder="请输入班级名称（例：21电商1班）"
              ></el-input>
            </el-form-item>
            <el-form-item label="班级封面" prop="icon">
              <el-upload
                class="uploader"
                action="#"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="(file) => upload(file, 'icon')"
              >
                <el-image
                  class="upload_img"
                  v-if="classInfo.icon"
                  :src="classInfo.icon"
                  fit="cover"
                ></el-image>
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="课程选择" prop="courseId">
              <el-select
                v-model="classInfo.courseId"
                disabled
                placeholder="请选择课程"
              >
                <el-option
                  v-for="item in lessonList"
                  :key="item.courseId"
                  :label="item.title"
                  :value="item.courseId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-top: 60px">
              <el-button
                class="btn"
                type="primary"
                @click="submitForm('classInfo')"
                >修改</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="权重设置" name="2">
          <weight-set
            :weightInfo="weightInfo"
            :hideBack="true"
            :classId="Number($route.query.id)"
            :isEdit="true"
          />
        </el-tab-pane>
        <el-tab-pane label="助教管理" name="3">
          <div class="box">
            <div class="head">
              <!-- <el-input
                v-model="params.query"
                placeholder="搜索"
                size="small"
                style="float: left; width: 250px"
                ><el-button
                  slot="append"
                  size="small"
                  icon="el-icon-search"
                ></el-button>
              </el-input> -->
              <el-button
                type="primary"
                size="small"
                style="float: right"
                @click="
                  show = true;
                  getList();
                "
                >添加助教</el-button
              >
              <el-button
                type="danger"
                size="small"
                style="float: right; margin-right: 10px"
                @click="handleDelBatch"
                v-show="selectedIds.length != 0"
                >批量删除</el-button
              >
            </div>
            <el-table
              class="assistant_list"
              :data="aList"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                prop="nickName"
                label="姓名"
                width="80"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="sno"
                label="学号"
                width="120"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="添加时间"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column fixed="right" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="
                      getAssistantInfo(scope.row.assistantId);
                      currentAssistantId = scope.row.assistantId;
                      showSet = true;
                    "
                  >
                    设置权限
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click="handleDel(scope.row.assistantId)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog title="添加助教" :visible.sync="show" width="30%" center>
      <div style="text-align: center">
        <el-select v-model="userId" multiple placeholder="请选择学生">
          <el-option
            v-for="item in list"
            :key="item.userId"
            :label="item.name + ' ' + item.sno"
            :value="item.userId"
          >
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="handleAdd"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      class="setting-dialog"
      title="权限设置"
      :visible.sync="showSet"
      width="35%"
      center
    >
      <el-checkbox-group v-model="checkList">
        <el-checkbox label="ANNEX">允许管理“资料”模块</el-checkbox>
        <el-checkbox label="TASK">允许管理“实战”模块</el-checkbox>
        <el-checkbox label="WORKS">允许管理“作品圈”模块</el-checkbox>
        <el-checkbox label="ACTIVITY">允许管理“教学活动”模块</el-checkbox>
        <el-checkbox label="QUALITY">允许管理“素养评价”模块</el-checkbox>
        <el-checkbox label="QUESTION">允许使用“题库”模块</el-checkbox>
        <!-- <el-checkbox label="EXAM">允许管理“考试”模块</el-checkbox> -->
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="showSet = false">取消</el-button>
        <el-button type="primary" size="medium" @click="handleSet"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { studentList } from "@/api/student";
import { courseList } from "@/api/course";
import { classInfo, editClass, classWeightInfo } from "@/api/class";
import {
  assistantList,
  addAssistant,
  delAssistant,
  assistantPermission,
  editAssistantPermission,
} from "@/api/assistant";
import upload from "@/utils/uploadMethod";
import weightSet from "../home/settings.vue";
export default {
  components: { weightSet },
  data() {
    return {
      activeName: "1",
      classInfo: {},
      rules: {
        name: {
          required: true,
          message: "请输入班级名称",
          trigger: "blur",
        },
        icon: {
          required: true,
          message: "请上传班级封面",
          trigger: "blur",
        },
        courseId: {
          required: true,
          message: "请选择课程",
          trigger: "blur",
        },
      },
      lessonList: [],
      show: false,
      //   params: {
      //     classId: this.$route.query.id,
      //     query: "",
      //   },
      aList: [],
      selectedIds: [],
      list: [],
      userId: null,
      showSet: false,
      checkList: [],
      currentAssistantId: null,
      weightInfo: {},
    };
  },
  created() {
    this.getClassInfo();
    this.getWeightInfo();
    this.getCourseList();
    this.getAssistantList();
  },
  methods: {
    // 班级信息
    getClassInfo() {
      this.$loading.show();
      classInfo(this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.classInfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    // 课程列表
    getCourseList() {
      courseList().then((res) => {
        if (res.code == 0) {
          // console.log(res);
          this.lessonList = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    getWeightInfo() {
      classWeightInfo(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.weightInfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    //上传图片
    async upload(file, str) {
      const fileUrl = await upload(file);
      this.classInfo[str] = fileUrl;
    },
    // 修改班级信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$loading.show();
          editClass(this.classInfo).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.getClassInfo();
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getList() {
      studentList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // 助教列表
    getAssistantList() {
      assistantList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.aList = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // 新增助教
    handleAdd() {
      this.$loading.show();
      addAssistant({ classId: this.$route.query.id, ids: this.userId }).then(
        (res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.$message.success("添加成功");
            this.getAssistantList();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
      this.show = false;
      this.userId = null;
    },
    // 获取权限列表
    getAssistantInfo(assistantId) {
      this.$loading.show();
      assistantPermission(assistantId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.checkList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 权限设置
    handleSet() {
      this.$loading.show();
      editAssistantPermission({
        assistantId: this.currentAssistantId,
        list: this.checkList,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("设置成功");
        } else {
          this.$message.error(res.msg);
        }
      });
      this.showSet = false;
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.assistantId);
    },
    // 删除助教
    handleDel(ids) {
      this.$confirm(`确定要删除吗?`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delAssistant(ids).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getAssistantList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleDelBatch() {
      this.handleDel(this.selectedIds);
    },
  },
};
</script>

<style lang="less" scoped>
.class-settings {
  background-color: rgb(248, 248, 248);
  .container {
    ::v-deep .el-page-header {
      margin: 40px 0 30px;
      .el-page-header__content {
        font-size: 14px;
      }
    }
    .uploader {
      width: 227px;
      height: 152px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        border-color: teal;
      }

      .el-icon-plus {
        font-size: 28px;
        color: #8c939d;
        width: 104px;
        height: 104px;
        line-height: 104px;
        text-align: center;
      }

      .upload_img {
        width: 227px;
        height: 152px;
        display: block;
      }
    }

    .el-select {
      width: 100%;
    }
    .btn {
      width: 120px;
    }
    .box {
      padding: 20px;
      .head {
        overflow: hidden;
        ::v-deep .el-input-group__append {
          background-color: teal;
          border-color: teal;
          color: #fff;
        }
      }

      ::v-deep .assistant_list {
        margin-top: 25px;
        .is-leaf {
          color: #333;
          background-color: #f5f5f5;
        }
      }
    }
  }
  .setting-dialog {
    ::v-deep .el-checkbox {
      display: block;
      margin-bottom: 30px;
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: inherit;
      }
    }
  }
}
</style>